import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DemarcheConfig, DemarcheItem, allDemarchesState, demarcheStored } from '@app/models/demarche';
import { of } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { FamilyService } from './family.service';

@Injectable({
  providedIn: 'root'
})
export class DemarcheService {

  configUrl = 'conf/demarche';
  cachedConfigDemarches: DemarcheConfig | null = null;

  constructor(
    private http: HttpClient,
    private familyService: FamilyService
  ) { }

  getConfig(adminMode: boolean = false) {

    if (this.cachedConfigDemarches && !adminMode) {
      return of(this.cachedConfigDemarches);
    }

    return this.http.get<DemarcheConfig>(this.configUrl)
      .pipe(tap(conf => this.cachedConfigDemarches = conf));
  }

  updateConfig(config: DemarcheConfig | any) {
    this.cachedConfigDemarches = null;
    return this.http.put(this.configUrl, { config });
  }

  getDemarcheById(id: number) {
    if (this.cachedConfigDemarches) {
      return of(this.cachedConfigDemarches).pipe(map(
        (conf: DemarcheConfig) => conf.demarches.find(
          (demarche: DemarcheItem) => demarche.id == id && demarche.enabled)
      ))
    }

    return this.getConfig().pipe(
      map(
        (conf: DemarcheConfig) => conf.demarches.find(
          (demarche: DemarcheItem) => demarche.id == id && demarche.enabled)
      )
    )
  }

  //Gestion du state managment dans le localStorage
  private readonly STORAGE_KEY = 'demarches-in-progress';

  private loadAll(): Record<number, demarcheStored> {
    const raw = localStorage.getItem(this.STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  }

  private saveAll(data: Record<number, demarcheStored>): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
  }

  save(idDemarche: number, data: demarcheStored): void {
    const all = this.loadAll();
    all[idDemarche + '' + this.familyService.currentFamily.id] = data;
    this.saveAll(all);
  }

  get(idDemarche: number, idFamille: number): demarcheStored | null {
    return this.loadAll()[idDemarche + '' + idFamille] || null;
  }

  getAll(): Record<number, demarcheStored> {
    return this.loadAll();
  }

  clear(idDemarche: number): void {
    const all = this.loadAll();
    delete all[idDemarche + '' + this.familyService.currentFamily.id];
    this.saveAll(all);
  }

  clearAll(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  hasProgress(idDemarche: number, idFamille: number): boolean {
    return !!this.get(idDemarche, idFamille);
  }
}
